import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class BindTelegramDto
*  Данные для осуществления привязки аккаунта телеграм к пользователю
*/
export class BindTelegramDto extends ActiveModel {

/**
  * tgLink
  * Ссылка для привязки
  */
  @ActiveField('')
  tgLink: string = ''
}
